exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userData[data-v-31bcbe14]{font-size:19px;font-weight:500;text-align:right;color:#fff;display:flex;align-items:center}aside[data-v-31bcbe14]{top:70px !important}", ""]);

// exports
